<nb-card>
  <nb-card-body class="p-0" style="min-height: 40px; overflow: hidden">
    <form tabindex="0" [formGroup]="kubernetesAccountForm" class="row mt-2">
      <div class="col-xl-12 col-md-12 col-xs-12">
        <app-reactive-form-field
          label="Name"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="name"
          fieldName="name"
          inputSize="7"
          placeholder="Enter unique name for the account"
          [customFormControl]="name"
          missingMsg="Name is required!"
          invalidPatternMsg="Kubernetes account name should be a lowercase alphanumeric string and can only have hyphens"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12">
        <app-reactive-form-field
          label="Host"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="host"
          fieldName="host"
          inputSize="7"
          placeholder="Host"
          [customFormControl]="host"
          missingMsg="Host is required!"
          invalidPatternMsg="Host is invalid!"
          [tooltipText]="'The hostname (in form of URI) of the Kubernetes API.'"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12">
        <app-reactive-text-area
          label="Certificate Authority"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="host"
          fieldName="host"
          inputSize="7"
          placeholder="Certificate Authority"
          [customFormControl]="certificateAuthority"
          missingMsg="Certificate Authority is required!"
          invalidPatternMsg="Certificate Authority is invalid!"
          [tooltipText]="
            'PEM certificate encoded in base64 format for the cluster\'s Certificate Authority (CA).'
          "
        ></app-reactive-text-area>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12">
        <app-reactive-text-area
          label="Token"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="token"
          fieldName="token"
          inputSize="7"
          placeholder="Token"
          [customFormControl]="token"
          missingMsg="Token is required!"
          invalidPatternMsg="Token is invalid!"
          [tooltipText]="'Token of the service account.'"
        ></app-reactive-text-area>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="p-0 pt-3">
    <app-rbac-button
      [label]="mode === 'create' ? 'Create' : 'Update'"
      class="mr-3"
      status="primary"
      [action]="ACCOUNTS_WRITE"
      [loading]="createUpdateInProgress"
      [disabled]="
        kubernetesAccountForm.invalid ||
        createUpdateInProgress ||
        verifyInProgress
      "
      (onClick)="createEditKubernetesAccount()"
    ></app-rbac-button>
    <app-rbac-button
      [label]="'Verify Account'"
      class="mr-3"
      status="primary"
      [action]="ACCOUNTS_WRITE"
      [loading]="verifyInProgress"
      [disabled]="
        kubernetesAccountForm.invalid ||
        createUpdateInProgress ||
        verifyInProgress
      "
      (onClick)="verifyAccount()"
      appearance="outline"
    ></app-rbac-button>
    <button
      nbButton
      size="small"
      class="mr-3"
      (click)="onClickHandleCancel(passRef)"
    >
      Cancel
    </button>
  </nb-card-footer>
</nb-card>
